























import { defineComponent, PropType } from '@vue/composition-api';
import { HighlightsImageMeta } from '../../model';

export default defineComponent({
	props: {
		meta: {
			type: Object as PropType<HighlightsImageMeta>,
			required: true,
		},
		inactive: Boolean,
	},
	setup(props, ctx) {
		const onClick = (e: MouseEvent) => {
			if (props.inactive) {
				e.preventDefault();
			} else {
				ctx.emit('click', e);
			}
		};
		return {
			onClick,
		};
	},
});
